import { render, staticRenderFns } from "./ImageCroppa.vue?vue&type=template&id=4ccc42d8"
import script from "./ImageCroppa.vue?vue&type=script&lang=js"
export * from "./ImageCroppa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports